"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    dividerVariants: ()=>dividerVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const directionVariants = {
    horizontal: {
        containerSlot: 'items-center'
    },
    vertical: {
        lineSlotBefore: 'mx-2',
        lineSlotAfter: 'mx-2'
    }
};
const typeVariants = {
    solid: '',
    dashed: {
        lineSlotBefore: 'border-dashed',
        lineSlotAfter: 'border-dashed'
    }
};
const isTextShownVariants = {
    true: '',
    false: ''
};
const isWeightVariants = {
    1: '',
    2: ''
};
const textAlignVariants = {
    left: '',
    center: ''
};
const dividerSlots = {
    containerSlot: 'flex gap-2 antialiased',
    lineSlotBefore: 'flex-1',
    lineSlotAfter: 'flex-1',
    textSlot: 'text-body2 max-w-80 truncate'
};
const emphasisVariants = {
    regular: '',
    bold: ''
};
const textAlignCompoundVariants = [
    {
        isTextShown: true,
        textAlign: 'left',
        class: {
            lineSlotBefore: 'w-4 flex-none'
        }
    }
];
const weightCompoundVariants = [
    {
        type: 'solid',
        direction: 'horizontal',
        weight: 1,
        class: {
            lineSlotBefore: 'h-px my-[9.5px]',
            lineSlotAfter: 'h-px my-[9.5px]'
        }
    },
    {
        type: 'solid',
        direction: 'vertical',
        weight: 1,
        class: {
            lineSlotBefore: 'w-px',
            lineSlotAfter: 'w-px'
        }
    },
    {
        type: 'solid',
        direction: 'horizontal',
        weight: 2,
        class: {
            lineSlotBefore: 'h-[2px] my-[9px]',
            lineSlotAfter: 'h-[2px] my-[9px]'
        }
    },
    {
        type: 'solid',
        direction: 'vertical',
        weight: 2,
        class: {
            lineSlotBefore: 'w-[2px]',
            lineSlotAfter: 'w-[2px]'
        }
    },
    {
        type: 'dashed',
        direction: 'horizontal',
        weight: 1,
        class: {
            lineSlotBefore: 'border-t-1 my-[9.5px]',
            lineSlotAfter: 'border-t-1 my-[9.5px]'
        }
    },
    {
        type: 'dashed',
        direction: 'vertical',
        weight: 1,
        class: {
            lineSlotBefore: 'border-l-1',
            lineSlotAfter: 'border-l-1'
        }
    },
    {
        type: 'dashed',
        direction: 'horizontal',
        weight: 2,
        class: {
            lineSlotBefore: 'border-t-2 my-[9px]',
            lineSlotAfter: 'border-t-2 my-[9px]'
        }
    },
    {
        type: 'dashed',
        direction: 'vertical',
        weight: 2,
        class: {
            lineSlotBefore: 'border-l-2',
            lineSlotAfter: 'border-l-2'
        }
    }
];
const emphasisCompoundVariants = [
    {
        type: 'solid',
        emphasis: 'regular',
        class: {
            lineSlotBefore: 'bg-neutral-6/50',
            lineSlotAfter: 'bg-neutral-6/50',
            textSlot: 'text-neutral-10'
        }
    },
    {
        type: 'dashed',
        emphasis: 'regular',
        class: {
            lineSlotBefore: 'border-neutral-7/40',
            lineSlotAfter: 'border-neutral-7/40',
            textSlot: 'text-neutral-10'
        }
    },
    {
        type: 'solid',
        emphasis: 'bold',
        class: {
            lineSlotBefore: 'bg-neutral-4/40',
            lineSlotAfter: 'bg-neutral-4/40',
            textSlot: 'text-neutral-1'
        }
    },
    {
        type: 'dashed',
        emphasis: 'bold',
        class: {
            lineSlotBefore: 'border-neutral-4/50',
            lineSlotAfter: 'border-neutral-4/50',
            textSlot: 'text-neutral-1'
        }
    }
];
const dividerCompoundVariants = [
    ...textAlignCompoundVariants,
    ...weightCompoundVariants,
    ...emphasisCompoundVariants
];
const dividerDefaultVariants = {
    type: 'solid',
    emphasis: 'regular',
    direction: 'horizontal',
    weight: 1
};
const dividerVariants = (0, tv_cjs_namespaceObject.tv)({
    variants: {
        type: typeVariants,
        isTextShown: isTextShownVariants,
        textAlign: textAlignVariants,
        direction: directionVariants,
        weight: isWeightVariants,
        emphasis: emphasisVariants
    },
    slots: dividerSlots,
    compoundVariants: dividerCompoundVariants,
    defaultVariants: dividerDefaultVariants
});
exports.dividerVariants = __webpack_exports__.dividerVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "dividerVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
